import { FeedProperty } from '@/types/models'
import {
  DEFAULT_FEED_LAYOUT,
  ZERO_LOCATION_LAYOUT,
  LOCATION_FEED_LAYOUT
} from '../constants'
import { isNumber } from '@/utils/checks'
import { isLocationPageType } from '@/domain/useCases/pageTypeCheck'
import { PageType } from '@/types/models/PageType.model'

interface ComputeFeedLayout {
  (params: { centerCount?: number; pageType: PageType }): FeedProperty[]
}

export const computeFeedLayout: ComputeFeedLayout = ({
  centerCount,
  pageType
}) => {
  if (isNumber(centerCount) && centerCount === 0) {
    return ZERO_LOCATION_LAYOUT
  } else if (isLocationPageType(pageType)) {
    return LOCATION_FEED_LAYOUT
  } else {
    return DEFAULT_FEED_LAYOUT
  }
}
